import { Box } from '@chakra-ui/react';

/** Small count on a nav icon or label. Hidden at zero. */
export function NavCountBadge({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <Box
      position="absolute"
      top="-6px"
      right="-8px"
      minW="16px"
      h="16px"
      px="1"
      borderRadius="full"
      bg="red.500"
      color="white"
      fontSize="2xs"
      fontWeight="bold"
      lineHeight="16px"
      textAlign="center"
      aria-hidden
    >
      {count > 99 ? '99+' : count}
    </Box>
  );
}
